module.exports = __webpack_public_path__ + "img/ios_installation_screenshot.ab08f788.png";